import React, { forwardRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { Loader2 } from 'lucide-react';
const buttonVariants = cva('inline-flex items-center justify-center rounded-input font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none', {
  variants: {
    variant: {
      primary: 'bg-brand-600 text-white hover:bg-brand-700',
      secondary: 'bg-surface-200 text-text-primary hover:bg-surface-300',
      tertiary: 'bg-transparent text-text-primary hover:bg-surface-100',
      destructive: 'bg-error-600 text-white hover:bg-error-700'
    },
    size: {
      sm: 'h-8 px-3 text-sm',
      md: 'h-10 px-4 text-base',
      lg: 'h-12 px-6 text-lg'
    },
    fullWidth: {
      true: 'w-full'
    }
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
    fullWidth: false
  }
});
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant,
  size,
  fullWidth,
  isLoading,
  leftIcon,
  rightIcon,
  children,
  ...props
}, ref) => {
  return <button className={buttonVariants({
    variant,
    size,
    fullWidth,
    className
  })} ref={ref} disabled={isLoading || props.disabled} {...props} data-id="element-177">
        {isLoading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-178" /> : leftIcon ? <span className="mr-2" data-id="element-179">{leftIcon}</span> : null}
        {children}
        {rightIcon && !isLoading && <span className="ml-2" data-id="element-180">{rightIcon}</span>}
      </button>;
});
Button.displayName = 'Button';